// PushedIndicator — permanent green dot/check that surfaces wherever
// a party's name renders, once they've been pushed to Close. The
// timestamp comes from mi.parties.last_pushed_to_close_at, stamped
// inside the close-push transaction.
//
// Variants: 'inline' (small dot, sits next to a name) and 'badge'
// (larger chip, used on detail-page headers).
//
// Tooltip on hover: shows the push date. Doesn't link to Close — the
// brief / build_batch surfaces are where the Close lead URL lives.

interface PushedIndicatorProps {
  pushedAt: string | null;
  variant?: 'inline' | 'badge';
  className?: string;
}

export function PushedIndicator({ pushedAt, variant = 'inline', className = '' }: PushedIndicatorProps) {
  if (!pushedAt) return null;

  const date = pushedAt.slice(0, 10);
  const tooltip = `Pushed to Close ${date}`;

  if (variant === 'badge') {
    return (
      <span
        title={tooltip}
        className={
          'inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-mono uppercase tracking-wider rounded border border-green/40 bg-green/10 text-green ' +
          className
        }
      >
        <span className="text-green">●</span>
        pushed {date}
      </span>
    );
  }

  // Inline (default): a tiny green dot. Title attribute carries the
  // date so a hover gives the operator a reading without taking
  // horizontal space in dense rows.
  return (
    <span
      title={tooltip}
      className={'inline-block text-green text-[11px] leading-none align-middle ' + className}
      aria-label={tooltip}
    >
      ●
    </span>
  );
}
